module.exports = "{\n  \"campaign\": {\n    \"utm_source\": \"utm_source\",\n    \"utm_medium\": \"utm_medium\",\n    \"utm_term\": \"utm_term\",\n    \"utm_content\": \"utm_content\",\n    \"utm_campaign\": \"utm_campaign\"\n  }\n}"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/campaign/config/campaignUrlParams.json
// module id = 890
// module chunks = 0